const SET_CUSTOMER_ID = 'SET_CUSTOMER_ID'
const SELECT_SET_CUSTOMER_DATA = 'SELECT_SET_CUSTOMER_DATA'
const SELECT_SET_REFER_CUSTOMER_DATA = 'SELECT_SET_REFER_CUSTOMER_DATA'
const SET_CUSTOMER_FILTER = 'SET_CUSTOMER_FILTER'
const SET_INSURER_LIST_ACTIVE = 'SET_INSURER_LIST_ACTIVE'
const SET_INSURER_COMPANY_ID = 'SET_INSURER_COMPANY_ID'
const SET_INSURER_PLAN_LIST = 'SET_INSURER_PLAN_LIST'
const SET_REFER_CUSTOMER_ID = 'SET_REFER_CUSTOMER_ID'

const state = {
  customerId: 0,
  referCustomerId: '',
  selectCustomerData:{},
  selectReferCustomerData:{},
  customerFilter: {}, // customer里面的policy，quote，ticket筛选项
  insurerListActive: 0,
  insurerCompanyId: null,
  insurerPlanList: []
}

const mutations = {
  [SET_CUSTOMER_ID]: (state, value) => {
    state.customerId = value
  },
  [SET_REFER_CUSTOMER_ID]: (state, value) => {
    state.referCustomerId = value
  },
  [SELECT_SET_CUSTOMER_DATA]: (state, value) => {
    state.selectCustomerData = value

  },
  [SELECT_SET_REFER_CUSTOMER_DATA]: (state, value) => {
    state.selectReferCustomerData = value
  },
  [SET_CUSTOMER_FILTER]: (state, value) => {
    state.customerFilter = value
  },
  [SET_INSURER_LIST_ACTIVE]: (state, value) => {
    state.insurerListActive = value
  },
  [SET_INSURER_COMPANY_ID]: (state, value) => {
    state.insurerCompanyId = value
  },
  [SET_INSURER_PLAN_LIST]: (state, value) => {
    state.insurerPlanList = value
  }
}

const actions = {
  setCustomerId({ commit }, val) {
    commit(SET_CUSTOMER_ID, val)
  },
  setReferCustomerId({ commit }, val) {
    commit(SET_REFER_CUSTOMER_ID, val)
  },
  setSelectCustomerData({ commit }, val) {
    commit(SELECT_SET_CUSTOMER_DATA, val)
  },
  setSelectReferCustomerData({ commit }, val) {
    commit(SELECT_SET_REFER_CUSTOMER_DATA, val)
  },
  setCustomerFilter({ commit }, val) {
    commit(SET_CUSTOMER_FILTER, val)
  },
  setinsurerListActive({commit}, val){
    commit(SET_INSURER_LIST_ACTIVE, val)
  },
  setInsurerCompanyId({commit}, val){
    commit(SET_INSURER_COMPANY_ID, val)
  },
  setInsurerPlanList({commit}, val){
    commit(SET_INSURER_PLAN_LIST, val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
